import { COMPONENT_TYPES } from '../../../constants';
import LoginComponent from './Login.component';
import LoginEditor from './Login.editor';
import LoginProperties from './Login.properties';
import { registerComponent } from '../registry';

// 레지스트리에 Login 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.LOGIN,
  component: LoginComponent,
  editorComponent: LoginEditor,
  properties: LoginProperties,
  defaultProps: {
    redirectUrl: '/',
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      maxWidth: '500px',
      margin: '30px auto'
    }
  },
  category: 'form',
  icon: '🔑',
  name: '로그인'
});

// 컴포넌트 및 타입 내보내기
export { default as LoginComponent } from './Login.component';
export { default as LoginEditor } from './Login.editor';
export { default as LoginProperties } from './Login.properties';
export * from './Login.types'; 